export default __webpack_public_path__ + "static/media/1.ab8f5c54.mp4";